<template>
    <div
        class="oc-context-menu shadow p-3 mb-5 bg-white rounded"
        v-class="{'oc-context-menu--active': visible}"
        v-click-outside="hideContextMenu"
    >
        <slot :hide="hideContextMenu">
            <template v-for="(action, index) in actions">
                <div
                    v-if="action === '---'"
                    class="dropdown-divider"
                />
                <oc-action
                    v-else
                    :key="index"
                    :row="item"
                    v-bind="action"
                    class="dropdown-item"
                    v-class="action.class"
                    @click="hideContextMenu"
                />
            </template>
        </slot>
    </div>
</template>

<script>
export default {
    name: 'oc-context-menu',
    props: {
        actions: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            visible: false,
            item: null
        }
    },
    methods: {
        showContextMenu (event, item)
        {
            this.item = item

            let menu = this.$el

            let mousePosY = event.clientY
            let mousePosX = event.clientX

            // calc menu width/height
            menu.style.top = "0px"
            menu.style.left = "0px"
            menu.style.visibility = "hidden"
            menu.style.display = "block"
            let menuWidth = menu.offsetWidth
            let menuHeight = menu.offsetHeight

            let {top: offsetHeight, left: offsetWidth} = this.getPosition(menu)

            offsetWidth = offsetWidth-1
            offsetHeight = offsetHeight-1

            menu.removeAttribute("style")
            //

            if ((menuWidth + mousePosX) >= window.innerWidth) {
                menu.style.left = (mousePosX - menuWidth - offsetWidth) + "px"
            } else {
                menu.style.left = (mousePosX - offsetWidth) + "px"
            }

            if ((menuHeight + mousePosY) >= window.innerHeight) {
                menu.style.top = (mousePosY - menuHeight - offsetHeight) + "px"
            } else {
                menu.style.top = (mousePosY - offsetHeight) + "px"
            }

            setTimeout(() => {
                this.visible = true
            }, 0)
        },
        getPosition(element)
        {
            var clientRect = element.getBoundingClientRect()

            return {
                left: clientRect.left + document.body.scrollLeft,
                top: clientRect.top + document.body.scrollTop
            }
        },
        hideContextMenu ()
        {
            this.visible = false
        },
        onEscKeyRelease (event)
        {
            if (event.keyCode === 27) {
                this.hideContextMenu()
            }
        }
    },
    mounted () {
        document.body.addEventListener('keyup', this.onEscKeyRelease)
    },
    beforeDestroy () {
        document.removeEventListener('keyup', this.onEscKeyRelease)
    }
}
</script>

<style scoped>
.oc-context-menu {
    top: 0;
    left: 0;
    margin: 0 !important;
    padding: 0 !important;
    display: none;
    position: absolute;
    z-index: 1000000;
}
    .oc-context-menu.oc-context-menu--active {
        display: block;
    }
    .oc-context-menu .dropdown-item:hover {
        background-color: #007aff;
        color: #fff;
    }
</style>
